import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  ref,
  getDownloadURL,
} from '@angular/fire/storage';
import * as fireStorage from '@angular/fire/storage';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-popupdocuplaod',
  templateUrl: './popupdocuplaod.component.html',
  styleUrls: ['./popupdocuplaod.component.scss']
})
export class PopupdocuplaodComponent {
  filetype: any = '.pdf'

  @ViewChild('fileInput')
  fileInput!: ElementRef;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private storage: fireStorage.Storage, public dialogRef: MatDialogRef<PopupdocuplaodComponent>, private elementRef: ElementRef) { }
  // @ViewChild('fileDropRef', { static: false }) fileDropEl!: ElementRef;\
  imageedit: boolean = false;
  imagelist: any = [];
  allowmultiple: boolean = true;
  isDeleted: boolean = false;
  imgObjArray: object[] = [];
  fromwhere: string = '';
  _bucketPath: any = '';
  collectionname: string = '';
  uploadfile: any;
  progress: number = 0;
  imgObj: any = {};
  docs: any;
  isuserdocs:boolean=false;
  maxlimit: boolean = false;
isbestworkchanged:boolean=false;



  headertoShown: string = ''
  files: any[] = [];
  imgfiles: any[] = []
  doctitle: string = '';
  docdesc: string = '';
  drawingid: any = '';
  ischoosefile: boolean = false;
  isOpen = false;
  doccategory: any = ''
  filetypeselected: any = 'PDF';
  imgfiletype: any = "image/*"
  pdffiletype: any = ".pdf";
  estimatefiletype: any = ".pdf"
  drawingversion: any = "";
  drawingcategory: any = "";
  drawingchanges: any = "";
  filetypename: string = "PDF"
  isfileadded: boolean = false;
  pdffile: any = "";
  imgfile: any = ''
  filelink: string = "";
  coverimagelink: string = ''
  filelinkarray: any[] = [];
  isloadingcomplete: boolean = false;
  isdwgloadingcomplete: boolean = false;
  isimageloadingcomplete: boolean = false;
  currentUser: any = {};
  refno: any;
  versionno: any;
  currentuserrole: any;
  isfileuploaderror: boolean = false;
  imageuploaderror: boolean = false;
  isdownloadurl: boolean = false;
  isadddoc: boolean = true;
  showimage: boolean = false;
  pdfbuttondisable: boolean = false
  pdfuploadnotcompleted: boolean = false;
  showpdfimgloading: boolean = false
  isimgupload: boolean = false
  coverimgdisabled: boolean = false;
  urlsrc: any = "./../../../../assets/testimgs/pdfplaceholder.png";
  urlsrcc: any;
  filetypelist: any;
  categorylist: any=['Elevation','Structural drawing','Electrical drawing','License drawing','Architectural drawing','Plumbing drawing','Survey drawing','Estimate'];
  admindocs: any;
  firstPageImage: string | ArrayBuffer | null = null;
  fileinput: any;
bestworkdata:any
  ngAfterViewInit() {
    this.fileinput = this.elementRef.nativeElement.querySelector('#fileInput');

    // this.fileinput =this.elementRef.nativeElement.querySelector('#fileDropRef');
    console.log(this.fileinput);

  }
  // doctitle:any
  ngOnInit(): void {

    if(this.data.fromwhere=='bestworks'){
      this.isloadingcomplete=true;
      this.filetype=this.imgfiletype
      this.imgfiles=[]
      this.bestworkdata = Object.assign({},this.data.edititems)

// if(this.bestworkdata){
//   // this.filelinkarray= this.bestworkdata.companybestworksimage
// console.log(this.filelinkarray);
// this.imgfiles=this.bestworkdata.companybestworksimage
// }
       
        this.ischoosefile=true
    }

    console.log(this.categorylist);

  }




  async fileBrowseHandler(files: any) {

    this.prepareFilesList(files.files);
    console.log(files.files);
    
  }

  async prepareFilesList(files: Array<any>) {

    this.isfileadded = true;
    console.log(files)
    for (const item of files) {
      item.progress = 0;
      const reader = new FileReader();
      reader.onload = (e: ProgressEvent) => {
        item.url = (<FileReader>e.target).result;
        this.urlsrcc = (<FileReader>e.target).result;

      };
      await reader.readAsDataURL(item);



      if (this.isimgupload) {
        this.isimageloadingcomplete = true;
        this.imgfiles.push(item);
        console.log(this.imgfiles)
        if (this.imgfiles && this.imgfiles.length > 0) {
          this.startUpload(this.imgfiles);

        }
      }

      else {
        this.files = [];
        console.log(item)
        this.files.push(item);
        this.ischoosefile = true;
        console.log(files);
        console.log(this.showimage)
        if (this.showimage) {
          reader.onload = (e: ProgressEvent) => {

            this.urlsrcc = (<FileReader>e.target).result;
            this.urlsrc = this.urlsrcc
            console.log(this.urlsrc)
          };



        }
        if (this.files && this.files.length > 0) {
          this.startUpload(this.files);
        }
      }
    }
  }
  async startUpload(files: any) {
    console.log(files);

    this.progress = 0;
      this.isloadingcomplete = false;
    let currentFile = files[0];
    const basePath = `${this._bucketPath
      }/${new Date().getFullYear()}/${Date.now()}_${currentFile.name}`;
    const storageRef = fireStorage.ref(this.storage, basePath);
    const uploadTask = fireStorage.uploadBytesResumable(storageRef, currentFile);
    uploadTask.on(
      'state_changed',
      async (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        this.progress = progress;
        switch (snapshot.state) {
          case 'paused':
            break;
          case 'running':
            break;
        }
      },
      (error) => {
        console.log('error.....', error);
      },
      async () => {
        console.log('unsubscribe');
      }
    );
    uploadTask.then(async () => {
      await getDownloadURL(storageRef).then((url) => {
        this.isloadingcomplete = true;
    
if(this.data.fromwhere=="bestworks"){
  this.filelinkarray.push(url);
  this.fileInput.nativeElement.value = '';
  this.isbestworkchanged=true
}
        {
          this.filelink = url;
          console.log(this.filelink);

        }

        console.log("drawing....", this.filelink);

        this.isimgupload = false
        this.isimageloadingcomplete = false;
        this.fileInput.nativeElement.value = '';

      })
      console.log(this.filelinkarray);
      
    })
  }

  saveToServer(reqform: NgForm) {
    console.log(reqform);
    console.log(this.ischoosefile);
    if (!this.ischoosefile || reqform.invalid ) {
      console.log(this.ischoosefile)
      if (!this.ischoosefile) {
        this.isfileuploaderror = true;
        console.log(this.ischoosefile)
      }

      if (reqform.invalid) {
        console.log(this.ischoosefile)

        Object.keys(reqform.form.controls).forEach((key) => {
          reqform.form.get(key)?.markAsDirty(); //mark dirty if fields are empty
        });
      }
    }
    else {
      if(this.data.fromwhere=="userdocument"){  
      this.imgObj.title = reqform.value.uploaddoctitle;
      this.imgObj.description = reqform.value.caption?reqform.value.caption:'';
this.imgObj.refno= 'CLIDOC' + new Date().getTime()
      this.imgObj.type = this.filetype;
      this.imgObj.downloadURL = this.filelink;
      
      if (this.imgObj.downloadURL) {
        this.isdownloadurl = true;
        console.log(this.imgObj.downloadURL)
      }
  
      // this.imgObj.bywhom = this.data?.bywhom;
      // this.imgObj.bywhomname = this.data?.bywhomname;
      this.imgObj.cdate = new Date().getTime();


    

    this.imgObj.isdeleted = false;

    this.imgObj.lasteditdate = new Date().getTime();
    }

    else if (this.data.fromwhere=='bestworks') {
      if (this.filelinkarray?.length > 10) {
        console.log(this.filelinkarray.length);
        // this.isfileuploaderror = true;
        this.maxlimit = true;
        console.log(this.maxlimit);
        // this.isfileuploaderror=false

        return;
      } else {
        this.isdownloadurl = true;
        this.isfileuploaderror = false;


      
        console.log(this.filelinkarray);
       
        if (this.filelinkarray) {
          this.imgObj.downloadURL = this.filelinkarray;

        }
        if (
          this.imgObj.downloadURL &&
          this.imgObj.downloadURL?.length != 0
        ) {
          this.isdownloadurl = true;
        }
      }
    }

  }

    if (this.isdownloadurl) {
      console.log(this.imgObj);

      this.imgObjArray.push(this.imgObj);
      this.dialogRef.close( this.imgObjArray);
    


     
    } else {
      // this.uxservice.openSnackBar('Upload not yet completed', 'OK');
    }

  

  }

  geturldata(url: string) {
    //  To get stored doc name form firebase storage
    const storageRef = ref(this.storage, url);
    // console.log(storageRef.name);
    const filename = storageRef.name.split("_")[1];
    // console.log(filename);
    return filename;

  }
  editImage(imageurl: any) {
    console.log(imageurl);
    // imageurl = ""
    this.ischoosefile = false;

    this.imageedit = true;
  }

  removeBestworkImage(item: any, index: any) {
console.log( this.filelinkarray);
this.isbestworkchanged=true

    console.log(item)
    console.log(index)
    console.log( this.data)

    this.filelinkarray.splice(index, 0)
    this.imgfiles.splice(index, 1)
    console.log(this.filelinkarray)
    if (this.filelinkarray && this.filelinkarray.length == 0) {

      this.ischoosefile=false;
    }
   

      console.log(this.filelinkarray)
      if (this.filelinkarray?.length <= 10) {

        this.maxlimit = false;

      }
      if (this.filelinkarray?.length >= 10) {

        this.maxlimit = true;

      }
    
  }

  removeImage(item: any, index: any) {
    this.imagelist.splice(index, 1);
    this.filelinkarray.splice(index, 1);
    console.log(this.filelinkarray)
    console.log(this.imagelist)
    if (this.imagelist && this.imagelist.length == 0) {
      this.files = [];
      this.filelinkarray = [];
      this.isdownloadurl = false;
      // this.fileinput.value = '';
      this.isfileuploaderror = true;

      console.log("sbjs")
    }
    if (this.data.fromwhere === "sitevisit") {

      console.log(this.filelinkarray)
      if (this.filelinkarray?.length <= 10) {
        // this.isfileuploaderror = true;
        this.maxlimit = false;

      }
      if (this.filelinkarray?.length >= 10) {
        // this.isfileuploaderror = true;
        this.maxlimit = true;

      }
    }

    console.log(this.files);
  }
  deleteEntry(eve: any, index: number) {
    // console.log(index);
    // console.log(this.filelinkarray);
    this.files.splice(index, 1);
    this.filelinkarray.splice(index, 1);
    if (this.files.length == 0) {
      this.isfileadded = false
    }
    // this.files.splice(this.files.indexOf(eve.local), 1); //displayfiles
    // this.imgObjArray.splice(this.imgObjArray.indexOf(eve.firestore), 1);//savingtofirestorefiles
  }

  selectionChange(event: any) {
    console.log(event);
   if(event.value!=='Other'){
    this.isuserdocs=false;
   
    
    // this.docs = this.admindocs.filter((ele: any) => ele.title == event.value)[0];
// this.refno=this.docs.id
    // this.filetypelist = this.docs.fileformat
    console.log(this.refno);
    if (this.filetypelist) {
      this.filetypeselected = this.filetypelist[0];
      console.log(this.filetypeselected);
      if (this.filetypeselected == 'PDF') {
        console.log("ppppppppppppp");
        
        this.filetype = '.pdf'
      }
      else {
        console.log("iiiiiiiiiiii");
        
        this.filetype = "image/*"
      }
  
    }
   }
   else{
    this.isuserdocs=true;
    this.filetypeselected='PDF'
   }

  }


  closeModal(){
    this.dialogRef.close(false)
  }
  onSelectingfiletype(event: any) {
 
   
    
    if (event.value == 'PDF') {
      console.log("ppppppppppppp");
      
      this.filetype = '.pdf'
    }
    else {
      console.log("iiiiiiiiiiii");
      
      this.filetype = "image/*"
    }

  }
}
